import React from 'react';
import {
  ProgressDiv,
  ErrorMessage,
  RetryDiv,
} from '../../packages/content/view/businessContent/businessContentEdit/components/Document';
import { Progress, Tooltip, Icon, message } from 'antd';
import { BtnGroup } from '../..//packages/content/view/businessContent/businessContentEdit/components/ResourceDrawer';

const FILE_TYPE = {
  doc: 'Word',
  docx: 'Word',
  ppt: 'PPT',
  pptx: 'PPTX',
  pdf: 'PDF',
  xls: 'Xls',
  xlsx: 'Xlsx',
  srt: 'Srt',
  lrc: 'Lrc',
};

const FILE_TIP_COLOR = {
  doc: '#3B9AFB',
  docx: '#3B9AFB',
  srt: '#3B9AFB',
  lrc: '#3B9AFB',
  ppt: '#FF9913',
  pptx: '#FF9913',
  pdf: '#EC4C56',
  xls: '#20D264',
  xlsx: '#20D264',
};

export const ResourcesType = {
  ppt: 'ppt',
  pptx: 'pptx',
};

interface DocumentHolderProps {
  name: string;
  digitalUrlProgress?: any;
  pptCoverUrl?: string;
}

function DocumentHolder(props: DocumentHolderProps) {
  const { name, digitalUrlProgress = {}, pptCoverUrl } = props;
  const { digitalConversionProgress, uuid } = digitalUrlProgress;
  const retryPptConvert = (uuid: string) => {
    nx.$api
      .retry_ppt_convert({
        subject: alo7Nav.subject,
        uuid,
      })
      .then(() => {
        window.dispatchEvent(new CustomEvent('updateDigitalPptUrlProgress'));
      })
      .catch((err: any) => {
        message.error(err.message);
      });
  };
  const renderCover = () => {
    return (
      <img
        style={{
          maxHeight: '100%',
          maxWidth: '100%',
        }}
        src={pptCoverUrl}
      />
    );
  };

  const renderProgress = () => {
    return (
      (digitalConversionProgress !== -1 && (
        <>
          资源转化中 ...
          <br />
          <Progress
            percent={digitalConversionProgress}
            strokeColor={'#1cc5a5'}
            status="active"
            size="small"
          />
        </>
      )) || (
        <>
          <ErrorMessage>转换失败</ErrorMessage>
          <BtnGroup>
            <Tooltip title={'重新转换'} placement={'bottom'}>
              <RetryDiv
                onClick={e => {
                  e.stopPropagation();
                  retryPptConvert(uuid);
                }}>
                <Icon type="sync" />
              </RetryDiv>
            </Tooltip>
          </BtnGroup>
        </>
      )
    );
  };
  return (
    <div
      style={{
        width: '256px',
        height: '122px',
        background: window.alo7Theme.primaryColorLight,
        position: 'relative',
      }}>
      <div
        style={{
          position: 'absolute',
          top: 0,
          left: '11px',
          background:
            FILE_TIP_COLOR[
              name
                .toLowerCase()
                .split('.')
                .slice(-1)
                .join('.')
            ] || '',
          fontSize: '12px',
          color: '#fff',
          fontWeight: 700,
          padding: '0 0.7em 0 0.5em',
          borderRadius: '0 0 30% 0px / 0 0 90% 0',
          zIndex: 1,
        }}>
        {FILE_TYPE[
          name
            .toLowerCase()
            .split('.')
            .slice(-1)
            .join('.')
        ] || ''}
      </div>
      <div
        style={{
          width: '175px',
          height: '91px',
          background: '#fff',
          margin: '0 auto',
          position: 'relative',
          top: '31px',
          padding: '20px 15px',
        }}>
        <div
          style={{
            width: '61px',
            height: '12px',
            background: window.alo7Theme.primaryColor,
            marginBottom: '12px',
          }}
        />
        <div
          style={{
            width: '145px',
            height: '9px',
            background: 'rgba(181, 200, 197, 0.33)',
            marginBottom: '12px',
          }}
        />
        <div
          style={{
            width: '145px',
            height: '9px',
            background: 'rgba(181, 200, 197, 0.33)',
            marginBottom: '12px',
          }}
        />
      </div>
      {ResourcesType[
        name
          .toLowerCase()
          .split('.')
          .slice(-1)
          .join('.')
      ] && (pptCoverUrl || typeof digitalConversionProgress === 'number') && (
        <ProgressDiv>
          {(pptCoverUrl && renderCover()) ||
            (digitalConversionProgress === -2 ? '无需转换' : renderProgress())}
        </ProgressDiv>
      )}
    </div>
  );
}

export default DocumentHolder;
